import r from "react";
import { translate as e } from "@aws-amplify/ui";
import { useAuthenticator as t } from "@aws-amplify/ui-react-core";
import { Alert as i } from "../../../primitives/Alert/Alert.js";
var o = function o() {
  var _t = t(function (r) {
      return [r.error];
    }),
    o = _t.error;
  return r.createElement(r.Fragment, null, o ? r.createElement(i, {
    variation: "error",
    isDismissible: !0
  }, e(o)) : null);
};
export { o as RemoteErrorMessage };